import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import AppHeader from "../components/AppHeader";
import DisclaimerBanner from "../components/DisclaimerBanner";
import SiteFooter from "../components/SiteFooter";
import BusinessSearchPanel from "../components/BusinessSearchPanel";
import { Building2, ChevronLeft } from "lucide-react";

export default function BusinessSearch() {
  const [params] = useSearchParams();
  const caseId = params.get("case_id");
  const partyId = params.get("party_id");

  return (
    <div className="min-h-screen bg-white">
      <DisclaimerBanner />
      <AppHeader />
      <main className="max-w-[1300px] mx-auto px-6 py-10 md:py-14" data-testid="business-search-page">
        <div className="flex items-center gap-4 mb-6">
          <Link to={caseId ? `/case/${caseId}` : "/resources"} className="inline-flex items-center gap-1 text-sm text-slate-600 hover:text-slate-900 underline underline-offset-4">
            <ChevronLeft className="w-4 h-4" /> {caseId ? "Back to case" : "Back to Resources"}
          </Link>
        </div>
        <header className="mb-10 max-w-3xl">
          <div className="label-tiny mb-3">Directory</div>
          <h1 className="font-serif-display text-4xl md:text-5xl text-slate-900 leading-tight">
            <Building2 className="inline-block w-9 h-9 mr-2 -mt-2 text-slate-700" strokeWidth={1.75} />
            Business & Registered Agent Search
          </h1>
          <p className="mt-4 text-slate-600">
            Official public business-search databases for all 50 states and Washington, D.C.
            Locate exact legal names, entity types, formation states, statuses, registered
            agents, principal addresses, and more.
          </p>
          {caseId && (
            <div className="mt-4 border border-blue-200 bg-blue-50 px-4 py-3 text-sm text-blue-900" data-testid="active-case-banner">
              You are researching for a specific case. Records you save here will be attached to that case.
            </div>
          )}
        </header>
        <BusinessSearchPanel caseId={caseId} defaultPartyId={partyId} />
      </main>
      <SiteFooter />
    </div>
  );
}
